import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var toggleConnectAdvancedWindow = mutatorAction('toggleConnectAdvancedWindow', function (state) {
    var store = connectedAccountsStore();
    store.dialogWindowState.connectAdvancedOpen = state.connectAdvancedOpen;
});
//# sourceMappingURL=toggleConnectAdvancedWindow.js.map